export default "__VITE_ASSET__CaejlfqL__"